export class Lotes {
  id:number;
  especie:number;
  proveedor:number;
  fechaextracion:Date;
  fecharecepcion:Date;
  fechaproceso:Date;
  codigo:string;
  guia:string;
  ret:string;
  centro:string;

  constructor(id,especie,proveedor,codigo,fechaextracion,fecharecepcion,fechaproceso,centro,guia,ret){
    this.id = id;
    this.especie = especie;
    this.proveedor = proveedor;
    this.codigo = codigo;
    this.fechaextracion = fechaextracion;
    this.fecharecepcion = fecharecepcion;
    this.fechaproceso = fechaproceso;
    this.centro = centro;
    this.guia = guia;
    this.ret = ret;
  }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson(){
    let nul1 = '';
    let nul2 = '';
    let nul3 = '';
    if(this.guia != '' && this.guia != null){
      nul1 = `"guide":"${this.guia}",`;
    }
    if(this.ret != '' && this.ret != null){
      nul2 = `"ret":"${this.ret}",`;
    }
    if(this.centro != '' && this.centro != null){
      nul3 = `"headquarter":"${this.centro}",`;
    }

    return `{
      "data":{
        "type": "lot",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          "specie_id":"${this.especie}",
          "company_id":"${this.proveedor}",
          "extraction_date":"${this.fechaextracion}",
          "reception_date":"${this.fecharecepcion}",
          "proccess_date":"${this.fechaproceso}",
          `+nul1+`
          `+nul2+`
          `+nul3+`
          "code":"${this.codigo}"
        }
      }
    }`;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Lotes.ts